import React from 'react';
import UnAnsweredComponent
  from '../../components/unansweredComponent/UnAnsweredComponent';

const UnAnswered = () => {
  return (
    <div>
      <UnAnsweredComponent />
    </div>
  );
};

export default UnAnswered;
